import { useQuery } from "@tanstack/react-query";

import { getAdminInfo } from "../../core/admin.core";

export default function UserName() {
  const { data: me } = useQuery({
    queryFn: () => getAdminInfo(),
    queryKey: ["admin"],
  });

  return (
    <div className="bg-her-blue flex-center h-10 w-10 tracking-wider text-white font-medium uppercase rounded-full">
      {me?.email.slice(0, 2)}
    </div>
  );
}
